import { createContext, useContext } from "react";

export const LayoutContext = createContext(null);

// Custom hook for easier usage
export const useLayout = () => {
  return useContext(LayoutContext);
};
